// (c) 2020, SAS Institute Inc.

import axios from './Axios';
export * from './Axios';
export * from './HeaderName';
export default axios;
export { Method } from 'axios';
//# sourceMappingURL=index.js.map